import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../'

const { env } = window

const useSaveAccessRequestsMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { tenant } = useTenant()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const saveAccessRequests = async (accessRequests) => {
    const url = encodeURI(`${env.apiUrl}/tenants/${tenant.id}/accessRequests`)
    const response = await securedFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(accessRequests)
    })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ accessRequests }) => saveAccessRequests(accessRequests),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error submitting requests'),
    onSuccess: () => {
      queryClient.invalidateQueries('accessRequests')
      setMessage(
        'Access requests submitted. You will receive a confirmation email once your access has been activated.'
      )
    },
    onSettled: progressEnd
  })
}

export { useSaveAccessRequestsMutation }
